<div class="companies-infographic" style="text-align: center; padding-top: 70px; margin-bottom:0;padding-bottom:0">
    <div style="position: relative"><span id="fciSun" style="position: absolute; top: 100px; margin-left: -100px;"><img
                src="../../../../assets/fci-logo.png" width="115" />
            <div style="width: 180px; margin-left: 30px; display: inline-block; text-align: left;">
                <p style="position: relative; top: 26px" [style.opacity]="_opacity">FCI’s Environmental reports have
                    been making an impact. </p>
            </div>
        </span></div>
    <div id="rsHouse" style="display: inline-block; vertical-align: bottom">
        <div
            style="position: relative; background-image: url('../../../../assets/home/clsrshouse.png'); background-size: cover; margin-top: 0px; margin-right: -2px; padding-top: 0px; width: 183px; height: 520px; text-align: left;">
            <div id="rstxt" style="padding: 15px; color: #fff; padding-top: 224px; position: absolute;">
                <h6
                    style="font-family: Quicksand, sans-serif; font-weight: 700; letter-spacing: 0.1px; font-size: 15px;">
                    CLS<br />RISK SOLUTIONS</h6><br />
                <p style="font-size: 14px">INSURANCE<br /><br />Bespoke insurance solutions for commercial and
                    development property in the UK and EU. </p>
            </div>
        </div>
    </div>
    <div id="piHouse" style="display: inline-block; vertical-align: bottom">
        <!--div(style="margin-bottom: 0px; padding-bottom: 0px; border-bottom: 100px solid #305e93; border-left: 90px solid transparent; border-right: 90px solid transparent; border-top: 0px solid transparent;")-->
        <div
            style="position: relative; background-image: url('../../../../assets/home/pihouse.png'); background-size: contain; margin-left: -1px; margin-top: 0px; padding-top: 0px; width: 180px; height: 400px; text-align: left;">
            <div id="pitxt" style="padding: 15px; color: #fff; padding-top: 103px">
                <h6
                    style="font-family: Quicksand, sans-serif; font-weight: 700; letter-spacing: 0.1px; font-size: 15px;">
                    CLS<br />PROPERTY INSIGHT</h6><br />
                <p style="font-size: 14px;">SEARCH SOLUTIONS<br /><br />Residential and commercial property search
                    solutions and legal indemnity Insurance</p>
            </div>
        </div>
    </div>
    <div id="dataHouse" style="display: inline-block; vertical-align: bottom">
        <!--div(style="margin-bottom: 0px; padding-bottom: 0px; border-bottom: 100px solid #666769; border-left: 90px solid transparent; border-right: 90px solid transparent; border-top: 0px solid transparent;")-->
        <div
            style="position: relative; background-image: url('../../../../assets/home/datahouse.png'); background-size: cover; margin-top: 0px; padding-top: 0px; width: 180px; height: 455px; text-align: left;">
            <div id="datatxt" style="padding: 15px; color: #fff; padding-top: 157px">
                <h6
                    style="font-family: Quicksand, sans-serif; font-weight: 700; letter-spacing: 0.1px; font-size: 15px;">
                    CLS<br />DATA</h6><br />
                <p style="font-size: 14px;">PROPERTY DATA<br /><br />Data provider to lenders, insurers and the
                    conveyancing market</p>
            </div>
        </div>
    </div>
    <div id="gsHouse" style="display: inline-block; vertical-align: bottom">
        <!--div(style="margin-bottom: 0px; padding-bottom: 0px; border-bottom: 100px solid #2a2a2a; border-left: 90px solid transparent; border-right: 90px solid transparent; border-top: 0px solid transparent;")-->
        <div
            style="position: relative; background-image: url('../../../../assets/home/gshouse.png'); background-size: contain; background-repeat: no-repeat; margin-top: 0px; padding-top: 0px; width: 180px; height: 412px; text-align: left;">
            <div id="gstxt" style="padding: 15px; color: #fff; padding-top: 113px">
                <h6
                    style="font-family: Quicksand, sans-serif; font-weight: 700; letter-spacing: 0.1px; font-size: 15px;">
                    CLS<br />GROUP SERVICES</h6><br />
                <p style="font-size: 14px;">INDUSTRY SOLUTIONS<br /><br />Creative, centralised ousourcing for the
                    residential and commercial propery market</p>
            </div>
        </div>
    </div>
</div>